import i18n from '@/plugins/vue-i18n'

export const required = (field, trigger = 'blur') => ({
  required: true,
  message: i18n.t('common.validate.cmn-err-001', [field]),
  trigger,
  transform: (value) => (['string', 'number'].includes(typeof value) ? String(value).trim() : value),
})

export const requiredSelect = (field) => ({
  required: true,
  message: i18n.t('common.validate.cmn-err-002', [field]),
  trigger: 'change',
})

export const numberFormat = (field) => ({
  trigger: 'blur',
  validator: (_rule, value, callback) => {
    if (!value) {
      callback()
    }

    if (/^\d+$/g.test(value) && !String(value).includes('.')) {
      callback()
    } else {
      callback(
        new Error(i18n.t('common.validate.cmn-err-003', [field, i18n.t('common.validate.format.halfSizeNumber')]))
      )
    }
  },
})

export const numberBetween = (field, min, max) => ({
  trigger: 'blur',
  validator: (_rule, value, callback) => {
    const _value = parseInt(value)
    if (_value < min || _value > max) {
      callback(new Error(i18n.t('common.validate.cmn-err-008', [field, min, max])))
    } else {
      callback()
    }
  },
})

export const emailFormat = (field) => ({
  trigger: 'blur',
  message: i18n.t('common.validate.cmn-err-003', [field, i18n.t('common.validate.format.email')]),
  pattern:
    /^(([a-zA-Z0-9!#$%&'*+-/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~]+)*))@((([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
})

export const kanaFormat = (field) => ({
  trigger: 'blur',
  message: i18n.t('common.validate.cmn-err-003', [field, i18n.t('common.validate.format.fullSizeKana')]),
  pattern: /^[\u3040-\u309f|ー]*$/,
})

export const phoneFormat = (beforeChangePhoneNumber = null, trigger = 'blur') => ({
  trigger,
  validator: (_rule, value, callback) => {
    if (beforeChangePhoneNumber && value === beforeChangePhoneNumber) {
      callback()
      return
    }
    if (/^(090|080|070|050)/.test(value)) {
      if (/^(090|080|070|050)\d{8}$/.test(value)) {
        callback()
        return
      }
    } else {
      if (/^\d{10}$/.test(value)) {
        callback()
        return
      }
    }
    callback(new Error(i18n.t('common.validate.cmn-err-016')))
  },
})

export const password = (field, min = 7, max = 15, trigger = 'blur') => ({
  pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{7,15}$/,
  message: i18n.t('common.validate.cmn-err-014', [field, min, max]),
  trigger,
})

export const shiftjis = (message, trigger = 'blur') => ({
  pattern: /^[\u0020-\u007F\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uff00-\uffef\u4e00-\u9faf\ufa11\uD842\udfb7]*$/u,
  message,
  trigger,
})
